// import React, { useState, useEffect } from "react";
// import "./fastivelCalander.css";

// const API_KEY = "AIzaSyAQwLJNHFshJeSUdswiqtyoWmG0QP03Jp0";
// const CALENDAR_ID = "en.indian#holiday@group.v.calendar.google.com";

// function FastivelCalander() {
//   const [events, setEvents] = useState([]);
//   // Start from Jan 2024
//   const [currentMonth, setCurrentMonth] = useState(new Date("2024-01-01"));

//   useEffect(() => {
//     const fetchEvents = async () => {
//       // Extend range to include entire 2024 and 2025
//       const timeMin = new Date("2024-01-01").toISOString();
//       const timeMax = new Date("2025-12-31").toISOString();

//       const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(
//         CALENDAR_ID
//       )}/events?key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&singleEvents=true&orderBy=startTime`;

//       try {
//         const res = await fetch(url);
//         const data = await res.json();
//         setEvents(data.items || []);
//       } catch (error) {
//         console.error("Failed to fetch events:", error);
//       }
//     };

//     fetchEvents();
//   }, []);

//   const getDaysInMonth = (year, month) => {
//     const date = new Date(year, month, 1);
//     const days = [];
//     const firstDay = date.getDay();
//     const totalDays = new Date(year, month + 1, 0).getDate();

//     for (let i = 0; i < firstDay; i++) {
//       days.push(null);
//     }

//     for (let i = 1; i <= totalDays; i++) {
//       days.push(i);
//     }

//     return days;
//   };

//   const month = currentMonth.getMonth();
//   const year = currentMonth.getFullYear();
//   const days = getDaysInMonth(year, month);

//   const eventsMap = events.reduce((acc, event) => {
//     if (event.start?.date) {
//       acc[event.start.date] = event.summary;
//     }
//     return acc;
//   }, {});

//   const formatDate = (day) => {
//     return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
//   };

//   // Navigation boundaries (Jan 2024 to Dec 2025)
//   const isPrevDisabled = year === 2024 && month === 0;
//   const isNextDisabled = year === 2025 && month === 11;

//   return (
//     <div className="calendar-container">
//       <h1>Festival Calendar 2024-2025</h1>
//       <div className="nav">
//         <button
//           onClick={() => setCurrentMonth(new Date(year, month - 1))}
//           disabled={isPrevDisabled}
//         >
//           ◀
//         </button>
//         <h2>
//           {currentMonth.toLocaleString("default", {
//             month: "long",
//             year: "numeric",
//           })}
//         </h2>
//         <button
//           onClick={() => setCurrentMonth(new Date(year, month + 1))}
//           disabled={isNextDisabled}
//         >
//           ▶
//         </button>
//       </div>

//       <div className="calendar">
//         <div className="day">Sun</div>
//         <div className="day">Mon</div>
//         <div className="day">Tue</div>
//         <div className="day">Wed</div>
//         <div className="day">Thu</div>
//         <div className="day">Fri</div>
//         <div className="day">Sat</div>

//         {days.map((day, idx) => {
//           const fullDate = day ? formatDate(day) : "";
//           return (
//             <div key={idx} className="cell">
//               {day && (
//                 <>
//                   <div className="date">{day}</div>
//                   {eventsMap[fullDate] && (
//                     <div className="event">{eventsMap[fullDate]}</div>
//                   )}
//                 </>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// export default FastivelCalander;


import React from "react";

const FastivelCalander = () => {
  return (
    <div style={{ minHeight: "80vh", padding: "20px" }}>
      <h2>Hindu panchang Calendar</h2>
      <iframe
        src="https://hinducalendar.app/"
        title="Hindu panchang Calendar"
        width="100%"
        height="800"
        style={{ border: "none", borderRadius: "10px" }}
      />
    </div>
  );
};

export default FastivelCalander;
